import { useEffect, useRef } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Logo } from '../../components/Header/Header';
import { useAuthStore } from '../../stores/useAuthStore';

/** Вход по ссылке из бота (кнопка «Войти на сайт»): /auth/telegram?t=… */
export default function TelegramAuthPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { loginWithTelegram, error } = useAuthStore();
  const started = useRef(false);
  const token = params.get('t') || '';

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!token) return;
    loginWithTelegram(token)
      .then(() => navigate('/account', { replace: true }))
      .catch(() => {
        /* текст ошибки в сторе */
      });
  }, [token, loginWithTelegram, navigate]);

  const failed = !token || Boolean(error);

  return (
    <div className="auth-page">
      <div className="auth-page__backdrop" />
      <div className="auth-page__card">
        <div className="auth-page__logo">
          <Logo />
        </div>
        <h1 className="auth-page__title">{failed ? 'Ссылка не сработала' : 'Входим…'}</h1>
        <p className="auth-page__subtitle">
          {failed
            ? error || 'В ссылке нет ключа входа.'
            : 'Проверяем ссылку из Telegram-бота.'}
        </p>
        {failed && (
          <div className="auth-page__switch">
            Откройте бот и нажмите «Аккаунт на сайте» → «Войти на сайт» ещё раз
            или <Link to="/login">войдите по паролю</Link>.
          </div>
        )}
        <Link to="/" className="auth-page__back">
          ← На главную
        </Link>
      </div>
    </div>
  );
}
